module.exports = __webpack_public_path__ + "static/media/delete-rd.e9ff33ab.svg";